import styled from 'styled-components';
import { Skeleton, SkeletonLoader } from '@ardoq/loader';
import { FlexBox } from '@ardoq/layout';
import { s8 } from '@ardoq/design-tokens';
import { HEIGHT_COMPONENT_ITEM } from '../utils/consts';
import { LoadDataNotificationProps } from './PropTypes';

const ICON_SIZE = '18px';
const NAME_HEIGHT = '12px';
const STAGGER_DELAY_SECONDS = 0.1;
const NAME_WIDTHS = ['55%', '70%', '40%', '62%', '48%', '75%', '35%', '58%'];

const SkeletonRow = styled(FlexBox).attrs({ align: 'center', gap: 'small' })`
  height: ${HEIGHT_COMPONENT_ITEM}px;
  padding: 0 ${s8};
`;

export const LoadDataSkeleton = ({
  loadingScopeDataNotification,
}: LoadDataNotificationProps) => (
  <SkeletonLoader message={loadingScopeDataNotification ?? undefined}>
    {NAME_WIDTHS.map((nameWidth, index) => (
      <SkeletonRow key={nameWidth}>
        <Skeleton
          width={ICON_SIZE}
          height={ICON_SIZE}
          delay={index * STAGGER_DELAY_SECONDS}
        />
        <Skeleton
          width={nameWidth}
          height={NAME_HEIGHT}
          delay={index * STAGGER_DELAY_SECONDS}
        />
      </SkeletonRow>
    ))}
  </SkeletonLoader>
);
